import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/70">
      <div className="px-4 md:px-6 py-12 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="text-accent-500 font-bold text-lg" style={{ fontFamily: 'var(--font-heading)' }}>
              {siteInfo.name}
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-background-50/50">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-3">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-accent-500 transition-colors whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-accent-500 transition-colors whitespace-nowrap">关于我们</Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-3">热门分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm hover:text-accent-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-3">联系我们</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-500"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-accent-500"></i>
                <span>{siteInfo.wechat}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line text-accent-500"></i>
                <span>{siteInfo.weibo}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} {siteInfo.name} - 版权所有 | 娱乐资讯聚合平台
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span>京ICP备XXXXXXXX号</span>
            <span>京公网安备XXXXXXXXXX号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}